import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'

export default function SupportSystemPage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    submit(event.currentTarget)
  }

  return (
    <QuestionPage
      heading={t('pages.onboarding.supportSystem.heading')}
      buttons={[
        {
          text: t('pages.onboarding.supportSystem.options.strong-support'),
          value: 'strong-support',
        },
        {
          text: t('pages.onboarding.supportSystem.options.some-support'),
          value: 'some-support',
        },
        {
          text: t('pages.onboarding.supportSystem.options.limited-support'),
          value: 'limited-support',
        },
        {
          text: t('pages.onboarding.supportSystem.options.alone'),
          value: 'alone',
        },
      ]}
      onSubmit={handleSubmit}
    />
  )
}
